/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { styled, Typography, Button, DialogContent } from "@mui/material";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import ReportProblemIcon from '@mui/icons-material/ReportProblem'

const ACCENT_COLOR = '#EA580C'

export const StyledModalTitleContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '5px',
})

export const StyledModalTitle = styled(Typography)({
  fontSize: '20px',
  fontWeight: '600',
})

export const FieldRow = styled('div')({
  display: 'flex',
  gap: '20px',
  marginTop: '20px',
})

export const FieldColumn = styled('div')({
  flex: 1,
})

export const FieldLabel = styled(Typography)({
  fontSize: '13px',
  color: 'gray',
  marginBottom: '6px',
})

export const FieldValue = styled(Typography)({
  fontSize: '16px',
  fontWeight: '600',
})

export const StyledPhoneField = styled(PhoneInput)(({ borderColor }) => ({
  "&:hover": {
    "& .react-international-phone-input": {
      border: "2px solid #395bbd !important",
    },
  },
  "&:focus-within": {
    "& .react-international-phone-input": {
      border: "2px solid #1976d2 !important",
    },
  },
  "& .react-international-phone-input": {
    width: "100% !important",
    borderRadius: "0px 8px 8px 0px !important",
    height: "40px !important",
    borderColor: borderColor,
  },
  "& .react-international-phone-country-selector-button": {
    height: "40px !important",
    borderRadius: "8px 0px 0px 8px !important",
    borderColor: borderColor,
  },
}))

export const StyledPhoneWarningRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  marginTop: '8px',
  color: ACCENT_COLOR,
  fontSize: '13px',
})

export const StyledCreateButton = styled(Button)({
  textTransform: 'none',
  fontSize: '13px',
  backgroundColor: "#395bbd",
  '&:hover': {
    backgroundColor: "#395bbd",
  },
  borderRadius: '8px'
})

export const LoaderContainer = styled(DialogContent)({
  padding: '10px 20px',
  minHeight: "300px",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export const PhoneWarning = ({ label }) => (
  <StyledPhoneWarningRow>
    <ReportProblemIcon sx={{ fontSize: '14px' }} />
    {label}
  </StyledPhoneWarningRow>
)
